import React from 'react';
import { useNavigate } from 'react-router-dom';
import { formatReferralDisplayAddress } from '../utils/referralDisplayUtils';
import './BuyerAgreementCard.css';

const ReferralAgreementCard = ({ referral, isSuperAdmin = false }) => {
  const navigate = useNavigate();

  const formatCurrency = (val) => {
    if (val == null) return 'N/A';
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(val);
    } catch {
      return `$${val}`;
    }
  };

  const address = formatReferralDisplayAddress(referral);
  const sideLabel = referral.referral_side === 'seller' ? 'Seller Referral' : 'Buyer Referral';
  const fee = referral.expected_referral_fee_amount ?? referral.referral_fee_amount;
  const uploadedDate = referral.created_at ? referral.created_at.slice(0, 10) : null;

  return (
    <div className="buyer-agreement-card" onClick={() => navigate(`/referral-agreement/${referral.id}`)}>
      <div className="buyer-agreement-card-header">
        <h3 className="buyer-agreement-title">{address}</h3>
        <span className="buyer-agreement-type-label">{sideLabel}</span>
      </div>
      <div className="card-body">
        <div className="info-row">
          <span className="info-label">Receiving Agent</span>
          <span className="info-value">{referral.receiving_agent_name || 'N/A'}</span>
        </div>
        <div className="info-row">
          <span className="info-label">Expected Fee</span>
          <span className="info-value">{formatCurrency(fee)}</span>
        </div>
        {referral.close_of_escrow_due_date && (
          <div className="info-row">
            <span className="info-label">Closing</span>
            <span className="info-value">{referral.close_of_escrow_due_date}</span>
          </div>
        )}
      </div>
      <div className="card-footer">
        {isSuperAdmin && referral.skyslope_sync_status && (
          <div className="meta-row" style={{ marginBottom: '4px' }}>
            <span style={{ fontSize: '0.72rem', color: '#888' }}>TMS: {referral.skyslope_sync_status}</span>
          </div>
        )}
        {uploadedDate && <span className="upload-date">Added {uploadedDate}</span>}
      </div>
    </div>
  );
};

export default ReferralAgreementCard;
